export default {
  namespaced: true,
  state: {
    valid: false,
    activitySheet: "activity",
    activitySheetObj: {},
    date: {
      date: new Date(new Date().setHours(12, 59, 0, 0))
        .toISOString()
        .substr(0, 10),
      menu: false,
    },
    time: {
      time: null,
      menu: false,
    },
    duration: "",
    workout: {
      items: [],
      name: "",
      selected: [], // list of objects
      totals: {
        sets: null,
        reps: null,
        exercise: {},
        muscleGroup: {},
      },
    },
    exercise: {
      dialog: false,
      index: "",
      reps: "",
      exercise: "",
      muscleGroup: "",
      addOrEdit: "",
      selected: false,
      rowNumber: "",
      valid: false,
    },
    selectDeselectAll: "deselect",
    health: {
      list: ["Sucked", "", "Alright", "", "Awesome"],
      value: 3,
    },
    snackbar: {
      model: false,
      text: "Test",
      color: "secondary",
      timeout: 4000,
    },
  },
  getters: {},
  mutations: {
    UPDATE_ACTIVITY_STATE: (state, payload) => {
      if (payload.field && payload.subfield) {
        state[payload.state][payload.field][payload.subfield] = payload.value;
      } else if (payload.field) {
        state[payload.state][payload.field] = payload.value;
      } else {
        state[payload.state] = payload.value;
      }
    },
  },
  actions: {
    updateActivityState: ({ commit }, payload) => {
      commit("UPDATE_ACTIVITY_STATE", payload);
    },
  },
};
